import axios from "./apiConfig";
import QS from "qs";
import {message} from '../util/message'
import Axios from "axios";
import store from '../store/index'

export function GET(url, params) {
  return new Promise((resolve,reject)=>{
    axios.get(url, { params }).then(res=>{
      if(res.data.code !== -1 && res.status === 200) {
        resolve(res.data)
      }else {
        message(-1,res.data.msg || '服务器错误')
        reject(res)
      }
    })
  })
}

export function POSTBody(url, params) {
  return axios({
    url,
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    }
  });
}
export function POST(url, params) {
  return new Promise((resolve,reject)=>{
    axios.post(url, QS.stringify(params)).then(res=>{
      if(res.data.code === 0 && res.status === 200) {
        resolve(res.data)
      }else {
        message(-1,res.data.msg || '服务器错误')
        reject(res)
      }
    })
  })
}

export function Form(url, params) {
  return axios({
    url,
    data: params,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

export function JSONP(url, params) {
  return axios({
    adapter: "jsonp",
    url: url,
    params: params,
    callbackName: "JsonCallBack",
    method: "get"
  });
}

//单独配置请求超时时间
export function AxiosTime(url,params){
  return Axios({
    url: url,
    method: 'post',
    data:params,
    timeout:1000*60,
    transformRequest: [function (data) {
      // Do whatever you want to transform the data
      console.log(data);
      return data
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'sessionId':store.state.LOGINUSER.sid
    },
  })
}

export function exportFile(json,setparams){
  if(json[0] === '/'){
    let jsonArr = [...json];
    jsonArr.shift();
    json = jsonArr.join("");
  }
  let params = setparams || {};
  params.sessionId = store.state.LOGINUSER.sid;
  const arr = Object.entries(params).map(([key, val]) => `${key}=${val}`);
  const baseUrl = process.env.NODE_ENV === 'development' ? "http://192.168.120.87:9090/" :"/";
  const url = baseUrl + json + "?" + arr.join('&');
  window.open(url);
}
